import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MinCheckedDirective } from './min-checked.directive';
import { RequiredTrueDirective } from './required-true.directive';
import { ValidateMessageService } from './validate-message.service';

@NgModule({
  declarations: [RequiredTrueDirective, MinCheckedDirective],
  imports: [CommonModule],
  providers: [ValidateMessageService],
  exports: [RequiredTrueDirective, MinCheckedDirective]
})
export class ValidationModule {}

export * from './custom-validators';
export * from './min-checked.directive';
export * from './required-true.directive';
export * from './validate-message.service';
export * from './validation-patterns';
